export class StartLoading {
  public static readonly type = '[Navigation] Start Loading';
}

export class FinishLoading {
  public static readonly type = '[Navigation] Finish Loading';
}

export class InitNavState {
  public static readonly type = '[Navigation] Init';
}

export class SetLinks {
  public static readonly type = '[Navigation] Set Links';
  constructor(public links: any[]) {}
}
// export class SelectGame {
//   public static readonly type = '[Navigation] Select Game';
//   constructor(public gameSlug: string) {}
// }

export class ToggleSidebar {
  public static readonly type = '[Navigation] Toggle Sidebar';
}
